import Layout from "../../../../Components/Layout";
import React, { useEffect, useState } from "react";
import PurchaseTickets from "../../../../Components/User/Events/Checkout/PurchaseTickets";
import { useSelector, useDispatch } from "react-redux";
import { updEventData } from "../../../../ReduxSlice/Event/eventSlice";
import { UserEventById } from "../../../../utils/ApiConstant";
import useHttpHook from "../../../../Hooks/HttpHook";
import { useParams } from "react-router-dom";
import { dateFormatter, convertToTimeZone } from "../../../../utils/Helper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../../utils/notify";
const PurchaseTicketsPage = () => {
  const [loading, sendRequest, error] = useHttpHook();
  const [timezone, setTimeZone] = useState(null);
  const { eventId } = useParams();
  const dispatch = useDispatch();
  const EventData = useSelector((state) => state.event.data);

  const query = new URLSearchParams(window.location.search);
  const referralId = query.get("referralId");
  let redirectUrl = "/attendee-information/" + eventId;
  let backUrl = "/event-details/" + eventId;
  if (referralId) {
    redirectUrl += `?referralId=${referralId}`;
    backUrl += `?referralId=${referralId}`;
  }

  const EventStatus = useSelector((state) => state.event.status);
  useEffect(() => {
    if (EventStatus === false) {
      getEventData();
    }
  }, []);

  const getEventData = async () => {
    let event = await sendRequest(UserEventById + eventId, { method: "get" });
    dispatch(updEventData(event));
  };

  useEffect(() => {
    if (EventStatus !== false && EventData?.eventTiming?.startDate) {
      setTimeZone(
        convertToTimeZone(
          new Date(EventData.eventTiming.startDate),
          EventData.eventTiming?.timeZone
        )
      );
    }
  }, [EventStatus, EventData?.eventTiming?.startDate, EventData?.eventTiming?.timeZone]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const timing = EventData?.eventTiming || {};
  const timezoneLabel = timezone ? ` (${timezone}) ` : " ";
  const subHeading = EventData
    ? [
        dateFormatter(timing.startDate, "date", "ddd"),
        dateFormatter(timing.startDate),
        timezoneLabel,
        timing.displayStartTime === 1
          ? dateFormatter(timing.startTime, "time", "h:mm A")
          : "",
        "-",
        dateFormatter(timing.endDate),
        timezoneLabel,
        timing.displayEndTime === 1
          ? dateFormatter(timing.endTime, "time", "h:mm A")
          : "",
      ]
        .filter((part) => part !== "")
        .join(" ")
        .replace(/\s+/g, " ")
        .trim()
    : "";

  return (
    <>
      {EventStatus && EventData && (
        <Layout
          Heading={EventData.title}
          TitleClassName="event-tickets-title"
          HeadClassName="event-tickets-head"
          DetailsHead
          ExtraclassName="event-tickets-panel"
          BackAction={backUrl}
          SubHeading={subHeading}
        >
          <PurchaseTickets
            getEventData={getEventData}
            ticketType={EventData.ticketType}
            eventId={eventId}
            mainimage={
              EventData?.mainimage && EventData?.mainimage?.length > 0
                ? EventData?.mainimage
                : ""
            }
            redirectUrl={redirectUrl}
            title={EventData.title}
            isShowSplitPayment={
              EventData?.settings?.settings?.splitPaymentEnabled
            }
            minSplitOrderAmount={
              EventData?.settings?.settings?.minSplitOrderAmount
            }
            isShowRemainingTicket={
              EventData?.settings?.settings?.displayNoOfTicket
            }
          />
        </Layout>
      )}
    </>
  );
};

export default PurchaseTicketsPage;
